import { defineMessages } from "@/lib/i18n/messages";

export default defineMessages({
  es: {
    label: "Descarga la app de Ciudad Viva",
    title: "Ciudad Viva en tu bolsillo",
    body: "Descarga la app gratis y no te pierdas ningún evento.",
    download: "Descargar",
    close: "Cerrar banner",
  },
  en: {
    label: "Download the Ciudad Viva app",
    title: "Ciudad Viva in your pocket",
    body: "Download the free app and never miss an event.",
    download: "Download",
    close: "Close banner",
  },
});
